import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { InAppMessage } from "../../support.types";
import { requestSendMessage } from "./sendMessage.request";
import { SendMessageRequestBody } from "./sendMessage.types";

const useSendMessage = (
  options?: MutationOptions<
    InAppMessage,
    ApiServiceError<ApiError>,
    SendMessageRequestBody
  >,
) => {
  return useMutation({
    mutationFn: requestSendMessage,
    onError: toastServerError,
    ...options,
  });
};

export default useSendMessage;
